// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as bootstrap from 'bootstrap'
import "@fortawesome/fontawesome-free/css/all"
import "turbolinks-animate"
import moment from 'moment';
import Inputmask from 'inputmask';
import "../stylesheets/application_portal_app"

// Fullcalendar imports
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import frLocale from '@fullcalendar/core/locales/fr';
import 'bootstrap-icons/font/bootstrap-icons.css';


Rails.start()
Turbolinks.start()
moment().format();
Inputmask();

/* this code will enable Popover and Tooltip on any page */
document.addEventListener("turbolinks:load", function(event) {
    TurbolinksAnimate.init({ element: document.querySelector('main') });

    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
    })

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    tp_showToast();

    $(document).on('show.bs.modal', '#schedules_modal', function(e){
        var button = $(e.relatedTarget);
        var modalContentClass = button.data('content');
        var modalSize = button.data('size') ? ' modal-' + button.data('size') : '';
        $('#schedules_modal .modal-dialog').attr('class','modal-dialog' + modalSize);
        $('#schedules_modal .modal-body').empty();
        $('#schedules_modal .modal-body').html($(modalContentClass).clone());
        $('#schedules_modal .modal-body ' + modalContentClass).removeClass('d-none');
    })
});

function tp_showToast() {
    var toastElList = [].slice.call(document.querySelectorAll('.toast.toast-new'))
    var toastList = toastElList.map(function (toastEl) {
        toastEl.classList.remove("toast-new");
        return new bootstrap.Toast(toastEl).show();
    })
}

function tp_setIntervalWithTurbolinks(intervalFunction, milliseconds) {
    var interval = setInterval(intervalFunction, milliseconds);

    $(document).on('turbolinks:before-cache turbolinks:before-render', removeInterval);

    function removeInterval() {
        clearInterval(interval);
        $(document).off('turbolinks:before-cache turbolinks:before-render', removeInterval);
    }
}

window.moment = moment;
window.bootstrap = bootstrap;
window.tp_showToast = tp_showToast;
window.tp_setIntervalWithTurbolinks = tp_setIntervalWithTurbolinks;
window.fullcalendar = Calendar;
window.fullcalendarPlugins = [dayGridPlugin, interactionPlugin, bootstrap5Plugin];
window.fullcalendarFrLocale = frLocale;

